import { getCurrentLang } from './getCurrentLang'
import { translateContent } from './translateContent'

const currentLang = (typeof window !== 'undefined' && getCurrentLang(window.location)) || 'en'
const previousSlideAriaLabel = translateContent(currentLang, 'previousSlide')
const nextSlideAriaLabel = translateContent(currentLang, 'nextSlide')

export const SliderButtonsTranslation = {
  previous: previousSlideAriaLabel,
  next: nextSlideAriaLabel
}
